/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PccPatientDataUploadErrorCategory } from './PccPatientDataUploadErrorCategory';
import {
    PccPatientDataUploadErrorCategoryFromJSON,
    PccPatientDataUploadErrorCategoryFromJSONTyped,
    PccPatientDataUploadErrorCategoryToJSON,
    PccPatientDataUploadErrorCategoryToJSONTyped,
} from './PccPatientDataUploadErrorCategory';

/**
 * 
 * @export
 * @interface PccPatientDataUploadError
 */
export interface PccPatientDataUploadError {
    /**
     * 
     */
    category: PccPatientDataUploadErrorCategory;
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    additional_information?: string;
}



/**
 * Check if a given object implements the PccPatientDataUploadError interface.
 */
export function instanceOfPccPatientDataUploadError(value: object): value is PccPatientDataUploadError {
    if (!('category' in value) || value['category'] === undefined) return false;
    return true;
}

export function PccPatientDataUploadErrorFromJSON(json: any): PccPatientDataUploadError {
    return PccPatientDataUploadErrorFromJSONTyped(json, false);
}

export function PccPatientDataUploadErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): PccPatientDataUploadError {
    if (json == null) {
        return json;
    }
    return {
        
        'category': PccPatientDataUploadErrorCategoryFromJSON(json['category']),
        'id': json['id'] == null ? undefined : json['id'],
        'additional_information': json['additional_information'] == null ? undefined : json['additional_information'],
    };
}

export function PccPatientDataUploadErrorToJSON(json: any): PccPatientDataUploadError {
    return PccPatientDataUploadErrorToJSONTyped(json, false);
}

export function PccPatientDataUploadErrorToJSONTyped(value?: PccPatientDataUploadError | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'category': PccPatientDataUploadErrorCategoryToJSON(value['category']),
        'id': value['id'],
        'additional_information': value['additional_information'],
    };
}

